import React from 'react';
import './footer.css';

function footer() {
  return (
    <div className='footer-body'>
        <h1>Manna Rice Cake House</h1>
        <hr />
        <h4>For any questions or concerns contact below:</h4>
        <h3>전화/Phone: 423-227-8989</h3>
        <h3>이메일/Email: peter8456@gmail.com</h3>
        <h3>위치/Location: Collegedale, TN</h3>
        <a href="/dashboard">Admin Login</a>
    </div>
  )
}

export default footer